import { z } from 'zod';

export const UserSchema = z.object({
    id: z.string().optional(),
    email: z.string().email(),
    username: z.string().min(3).optional(),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    roleId: z.string().optional(),
    roleIds: z.array(z.string()).optional(),
    unitId: z.string().optional(),
    isActive: z.boolean().default(true),
    createdAt: z.date().optional(),
    updatedAt: z.date().optional(),
});
export const CreateUserSchema = UserSchema.omit({ id: true, createdAt: true, updatedAt: true });
export const UpdateUserSchema = UserSchema.partial();
export const UserFormSchema = UserSchema;
